import { _ as i } from "./index742.mjs";
import { p as a } from "./index788.mjs";
import { p as s } from "./index787.mjs";
import { g as m } from "./index793.mjs";
import { i as n } from "./index761.mjs";
import { d as p } from "./index740.mjs";
var c = i, f = a.CONSTRUCTOR, r = s, u = m, l = n, v = p, t = r && r.prototype;
c({ target: "Promise", proto: !0, forced: f, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
if (l(r)) {
  var o = u("Promise").prototype.catch;
  t.catch !== o && v(t, "catch", o, { unsafe: !0 });
}
